export const filterSettingsTimeclockPermissions = [
  'cipKioskMode',
  'HolidayOvertimeException',
  'PTOOvertimeException',
  'payrollActions',
  'timeClockFullAccess',
  'cipFullAccess',
]